import { UserInfoActions, UserInfoActionTypes } from '@appStore/account/actions/user-info.actions';
import { UserInfo } from '@model';
import { UserType } from '@enums';
import { UserRegistrationStatus } from 'app/models/enums/user-registration-status';

export interface State {
  isauthorized: boolean;
  isauthorizing: boolean;
  loaded: boolean;
  userInfoLoading: boolean;
  userinfo: UserInfo;
  userType: UserType;
  userRegisteredLoaded: boolean;
  userRegisteredLoading: boolean;
  userRegistered: UserRegistrationStatus;
  userIsLogingIn: boolean;
  userInfoUpdating: boolean;
  userInfoUpdated: boolean;
  userInfoExpired: boolean;
  userInfoExpiredLoaded: boolean;
  userInfoExpiredLoading: boolean;
  userInfoSetUpdatedLoaded: boolean;
  userInfoSetUpdatedLoading: boolean;
  userMarkedForInactivationLoaded: boolean;
  userMarkedForInactivationLoading: boolean;
  userMarkedForInactivation: boolean;
  userSetAsInactive: boolean;
  userSetAsInactiveLoading: boolean;
  userSetAsInactiveLoaded: boolean;
  userCanBeInactivatedLoaded: boolean;
  userCanBeInactivatedLoading: boolean;
  userCanBeInactivated: boolean;
  setStartupApplicationLoading: boolean;
  setStartupApplicationLoaded: boolean;
}

export const initialState: State = {
  isauthorized: false,
  isauthorizing: false,
  loaded: false,
  userInfoLoading:false,
  userinfo: null,
  userType: null,
  userRegisteredLoaded: false,
  userRegisteredLoading: false,
  userRegistered: UserRegistrationStatus.Available,
  userIsLogingIn: false,
  userInfoUpdating: false,
  userInfoUpdated: false,
  userInfoExpired: false,
  userInfoExpiredLoaded: false,
  userInfoExpiredLoading: false,
  userInfoSetUpdatedLoaded: false,
  userInfoSetUpdatedLoading: false,
  userMarkedForInactivationLoaded: false,
  userMarkedForInactivationLoading: false,
  userMarkedForInactivation: false,
  userSetAsInactive: false,
  userSetAsInactiveLoading: false,
  userSetAsInactiveLoaded: false,
  userCanBeInactivatedLoaded: false,
  userCanBeInactivatedLoading: false,
  userCanBeInactivated: false,
  setStartupApplicationLoading: false,
  setStartupApplicationLoaded: false
};

export function reducer(state = initialState, action: UserInfoActions): State {
  let oldUserInfo: UserInfo = state.userinfo;
  let newUserInfo: UserInfo;
  switch (action.type) {
    case UserInfoActionTypes.UserStartedLogin:
      return { ...state, userIsLogingIn: true };
  case UserInfoActionTypes.UserInfoLoad:
    return { ...state, userInfoLoading:true };
    case UserInfoActionTypes.UserInfoLoadItemSuccess:
      newUserInfo = action.payload;
      if (!state.loaded && (oldUserInfo === null || newUserInfo.name !== oldUserInfo.name || newUserInfo.email !== oldUserInfo.email || 
        newUserInfo.id !== oldUserInfo.id || newUserInfo.mobileNumber !== oldUserInfo.mobileNumber || oldUserInfo.email != newUserInfo.unValidatedEmail)) {
        return { ...state, userinfo: {...action.payload, intelligyOnboarding:state?.userinfo?.intelligyOnboarding }, isauthorized: true, loaded: true, userIsLogingIn: false, userInfoLoading:false };
      } else if (!state.isauthorized) {
        return { ...state, isauthorized: true, userIsLogingIn: false, userInfoLoading:false };
      } else {
        return state;
      }
    case UserInfoActionTypes.UserInfoLoadItemComplete:
      return { ...state, userType: action.payload, isauthorized: true, loaded: true, userIsLogingIn: false };
    case UserInfoActionTypes.UserInfoLoadItemFail:
      return { ...state, userinfo: null, isauthorized: false };
    case UserInfoActionTypes.UserInfoUpdateItem:
      return { ...state, userInfoUpdating: true, userInfoUpdated: false };
    case UserInfoActionTypes.UserInfoUpdateItemSuccess:
      newUserInfo = action.payload;

      if (oldUserInfo.impersonatedAsId) {
        newUserInfo = {
          ...oldUserInfo,
          impersonatedAsEmail: newUserInfo.email,
          impersonatedAsMobileNumber: newUserInfo.mobileNumber,
          impersonatedAsName: newUserInfo.name,
          impersonatedAsFirstName: newUserInfo.firstName,
          impersonatedAsLastName: newUserInfo.lastName
        };
      }

      return { ...state, userinfo: newUserInfo, userIsLogingIn: false, userInfoUpdating: false, userInfoUpdated: true, userInfoExpired: false };
    case UserInfoActionTypes.IsUserRegistered:
      return {
        ...state,
        userRegisteredLoaded: false,
        userRegisteredLoading: true,
        userRegistered: 0,
        userIsLogingIn: false
      };
    case UserInfoActionTypes.IsUserRegisteredSuccess:
      return {
        ...state,
        userRegisteredLoaded: true,
        userRegisteredLoading: false,
        userRegistered: action.payload,
        userIsLogingIn: false
      };
    case UserInfoActionTypes.IsUserRegisteredFail:
      return {
        ...state,
        userRegisteredLoaded: false,
        userRegisteredLoading: false,
        userIsLogingIn: false
      };
    case UserInfoActionTypes.HasUserInfoExpired:
      return {
        ...state,
        userInfoExpiredLoaded: false,
        userInfoExpiredLoading: true,
        userInfoExpired: false
      };
    case UserInfoActionTypes.HasUserInfoExpiredSuccess:
      return {
        ...state,
        userInfoExpiredLoaded: true,
        userInfoExpiredLoading: false,
        userInfoExpired: action.payload
      };
    case UserInfoActionTypes.HasUserInfoExpiredFail:
      return {
        ...state,
        userInfoExpiredLoaded: false,
        userInfoExpiredLoading: false
      };
    case UserInfoActionTypes.UserInfoSetUpdated:
      return {
        ...state,
        userInfoSetUpdatedLoaded: false,
        userInfoSetUpdatedLoading: true
      };
    case UserInfoActionTypes.UserInfoSetUpdatedSuccess:
      return {
        ...state,
        userInfoSetUpdatedLoaded: true,
        userInfoSetUpdatedLoading: false,
        userInfoExpired: false
      };
    case UserInfoActionTypes.UserEmailValidated:
      return {
        ...state,
        userinfo: { ...state.userinfo, email:state.userinfo.unValidatedEmail, unValidatedEmail: '', onBoardingComplete:true }
      };
    // case UserInfoActionTypes.SetIntelligyOnboarding:
    //   return{
    //     ...state,
    //     userinfo: { ...state.userinfo, intelligyOnboarding: true }
    //   };
    case UserInfoActionTypes.IsUserMarkedForInactivation:
      return {
        ...state,
        userMarkedForInactivationLoaded: false,
        userMarkedForInactivationLoading: true,
        userMarkedForInactivation: false
      };
    case UserInfoActionTypes.IsUserMarkedForInactivationSuccess:
      return {
        ...state,
        userMarkedForInactivationLoaded: true,
        userMarkedForInactivationLoading: false,
        userMarkedForInactivation: action.payload
      };
    case UserInfoActionTypes.IsUserMarkedForInactivationFail:
      return {
        ...state,
        userMarkedForInactivationLoaded: false,
        userMarkedForInactivationLoading: false
      };
    case UserInfoActionTypes.InactivateUser:
      return {
        ...state,
        userSetAsInactiveLoaded: false,
        userSetAsInactiveLoading: true,
      };
    case UserInfoActionTypes.InactivateUserSuccess:
      return {
        ...state,
        userSetAsInactiveLoaded: true,
        userSetAsInactiveLoading: false,
        userSetAsInactive: action.payload
      };
    case UserInfoActionTypes.InactivateUserFail:
      return {
        ...state,
        userSetAsInactiveLoaded: false,
        userSetAsInactiveLoading: false,
      };
    case UserInfoActionTypes.CanUserBeInactivated:
        return {
          ...state,
          userCanBeInactivatedLoaded: false,
          userCanBeInactivatedLoading: true,
          userCanBeInactivated: false
        };
    case UserInfoActionTypes.CanUserBeInactivatedSuccess:
        return {
          ...state,
          userCanBeInactivatedLoaded: true,
          userCanBeInactivatedLoading: false,
          userCanBeInactivated: action.payload
        };
    case UserInfoActionTypes.CanUserBeInactivatedFail:
        return {
          ...state,
          userCanBeInactivatedLoaded: false,
          userCanBeInactivatedLoading: false
        };
      case UserInfoActionTypes.SetStartupApplication:
        return{
          ...state,
          setStartupApplicationLoaded: false,
          setStartupApplicationLoading: true
        };
      case UserInfoActionTypes.SetStartupApplicationSuccess:
        return{
          ...state,
          setStartupApplicationLoaded: true,
          setStartupApplicationLoading: false,
          userinfo: { ...state.userinfo, startupApplication: action.payload }
        };
      case UserInfoActionTypes.SetStartupApplicationFail:
        return{
          ...state,
          setStartupApplicationLoaded: false,
          setStartupApplicationLoading: false
        };
  }
  return state;
}

export const getUserInfo = (state: State) => state.userinfo;
export const getUserInfoLoading = (state: State) => state.userInfoLoading;
export const getUserInfoLoaded = (state: State) => state.userinfo && state.loaded;
export const getUserIsAuthorized = (state: State) => state.isauthorized;
export const getUserIslogingIn = (state: State) => state.userIsLogingIn;
export const getUserType = (state: State) => state.userType;
export const getIsUserRegistered = (state: State) => state.userRegistered;
export const getIsUserRegisteredLoaded = (state: State) => state.userRegisteredLoaded;
export const getUserInfoUpdating = (state: State) => state.userInfoUpdating;
export const getUserInfoUpdated = (state: State) => state.userInfoUpdated;
export const getHasUserInfoExpired = (state: State) => state.userInfoExpired;
export const getHasUserInfoExpiredLoaded = (state: State) => state.userInfoExpiredLoaded;
export const getIsUserMarkedForInactivation = (state: State) => state.userMarkedForInactivation;
export const getIsUserMarkedForInactivationLoaded = (state: State) => state.userMarkedForInactivationLoaded;
export const getIsUserSetAsInactive = (state: State) => state.userSetAsInactive;
export const getIsUserSetAsInactiveLoaded = (state: State) => state.userSetAsInactiveLoaded;
export const getCanUserBeInactivated = (state: State) => state.userCanBeInactivated;
export const getCanUserBeInactivatedLoaded = (state: State) => state.userCanBeInactivatedLoaded;
export const getSetStartupApplicationLoading = (state: State) => state.setStartupApplicationLoading;
export const getSetStartupApplicationLoaded = (state: State) => state.setStartupApplicationLoaded;
